import BaseM from "./recordm.model.entity.js";
import RecordmImporterStatM from "./recordm.importer.model.stat.base.js";
import {format as formatDateTime} from "../fields/recordm.fields.datetime.js";

const RecordmImporterLineStatM = function(core, statJson) {
    RecordmImporterStatM.apply(this, [core, statJson]);
    this._entityKey = "rm-importer-line-stat";
};

RecordmImporterLineStatM.prototype = new RecordmImporterStatM();
RecordmImporterLineStatM.prototype.constructor = RecordmImporterLineStatM;

RecordmImporterLineStatM.prototype.getSearchableFields = function() {
    const _this = this;
    return [
        BaseM._buildEntityField("row_num", {
            label: this.core.translateString("recordm-importer.stats", "fields.rowNum"),
            visibleByDefault: true,
            type: BaseM.fieldDataType.NUMBER,
            columnWidth: 10,
            align: "right"
        }),
        BaseM._buildEntityField("end_date", {
            label: this.core.translateString("recordm-importer.stats", "fields.end_date"),
            visibleByDefault: true,
            type: BaseM.fieldDataType.DATETIME,
            align: "center",
            columnWidth: 20,
            formatter: function(value, context, def, locale) {
                if(value){
                    return formatDateTime(value, locale);
                }
                return "";
            }
        }),
        BaseM._buildEntityField("result", {
            label: this.core.translateString("recordm-importer.stats", "fields.result"),
            visibleByDefault: true,
            type: BaseM.fieldDataType.MULTIVALUE,
            columnWidth: 20,
            possibleValues:[
                {i18nFile:"recordm-importer.stats", i18nKey:"results.discarded", value:"DISCARDED"},
                {i18nFile:"recordm-importer.stats", i18nKey:"results.error", value:"ERROR"},
                {i18nFile:"recordm-importer.stats", i18nKey:"results.processed", value:"PROCESSED"}
            ],
            align: "center",
            formatter: function(value) {
                const result = value.toLowerCase();

                return (value
                       ? ('<div class="' + result + '-importer-stat">'
                          + _this.core.translateString("recordm-importer.stats", "result." + result)
                          + '</div>')
                       : value);
            }
        }),
        BaseM._buildEntityField("msg", {
            label: this.core.translateString("recordm-importer.stats", "fields.msg"),
            visibleByDefault: true,
            columnWidth: 200
        })
    ];
};

RecordmImporterLineStatM.prototype.isDiscarded = function(){
    return this.stat.result === "DISCARDED";
};

RecordmImporterLineStatM.prototype.hasError = function(){
    return this.stat.result === "ERROR";
};

RecordmImporterLineStatM.prototype.getRowNum = function() {
    return this.stat.row_num;
};

RecordmImporterLineStatM.prototype.getResult = function(){
    return this.stat.result;
};

RecordmImporterLineStatM.prototype.getMessage = function() {
    return this.stat.msg || "";
};

export default RecordmImporterLineStatM;
